import React, { useEffect } from "react";
import StructureSearchWrapper from "../components/search/structureSearch";
import Table from "../components/table/Table";
import Navbar from "../components/ui/navbar";
import Footer from "../components/ui/Footer";
import useTableStore from "../store/useTabStore";

const StructureSearch: React.FC = () => {
  const { resetFilter } = useTableStore();
  useEffect(() => {
    return () => {
      resetFilter();
    };
  }, [resetFilter]);
  return (
    <>
      <div className="relative flex-shrink-0 w-full py-8 border-b border-1">
        <Navbar />
      </div>
      <div className="flex flex-col flex-1 px-8 mx-6 lg:px-12">
        <div className="w-full">
          <StructureSearchWrapper />
        </div>
        <div className="w-full flex-1">
          <Table />
        </div>
        <Footer />
      </div>
    </>
  );
};

export default StructureSearch;
